import {Component, OnInit} from '@angular/core';
import {EvaluationService} from '../../services/evaluation.service';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
  selector: 'app-evaluation-settings',
  styleUrls: ['./evaluation-settings.component.scss'],
  templateUrl: './evaluation-settings.component.html'
})
export class EvaluationSettingsComponent implements OnInit {
  factors: any;
  isLoading: boolean;

  constructor(private evaluationService: EvaluationService,
              private toastMessagesService: ToastMessagesService) {
    this.isLoading = false;
  }

  public async ngOnInit(): Promise<void> {
    try {
      this.isLoading = true;
      this.factors = await this.evaluationService.fetchFactors();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  async updateFactors() {
    try {
      this.isLoading = true;
      if (!this.checkFactors()) {
        this.toastMessagesService.toastErrorMessage(`To άθροισμα των συντελεστών βαρύτητας θα πρέπει να είναι ίσο με 100`);
        return;
      }
      await this.evaluationService.updateFactors(this.factors);
      this.toastMessagesService.toastMessages(`Η ενημέρωση των συντελεστών ολοκληρώθηκε με επιτυχία`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  checkFactors() {
    const sum = +this.factors.year + +this.factors.internalWhite + +this.factors.internalLook + +this.factors.externalLook + +this.factors.windowState + +this.factors.neckState;
    return sum === 100;
  }
}
